export default class FinishPackingSlipModalController {
    constructor($uibModalInstance, packingDaisyService, $scope, Flash, $timeout) {
        this.$uibModalInstance = $uibModalInstance;
        this.packingDaisyService = packingDaisyService;
        this.$scope = $scope;
        this.Flash = Flash;
        this.$timeout = $timeout;

        this.boot();
    }

    boot() {
        this.shippingTypes = this.$scope.params.shippingTypes;
        this.packingSlip = this.$scope.params.packingSlip;
        this.changeShippingTypeAllowed = this.$scope.params.changeShippingTypeAllowed;
        this.availableServiceCodes = false;
        this.selectedShippingType = false;
        this.selectedServiceCodes = {};
        this.selectedServiceCodeToAdd = false;

        this.$uibModalInstance.rendered.then(() => {
            this.initJQuery();
        });
    }

    initJQuery() {

    }

    initServiceCodeInput() {
        var keyboardPosition = {
            of: $('.keyboard-container'),
            my: 'center top',
            at: 'center top',
            at2: 'center bottom'
        };

        $('.service-code-input').keyboard({
            layout: 'customnum',
            usePreview: false,
            autoAccept: true,
            position: keyboardPosition,
        });

        $('.service-code-input').bind('keyboardChange', function (e, keyboard, el) {
            $('.service-code-row').addClass('hidden');
            let currentSearchText = keyboard.$preview.val();
            $('.service-code-row').each(function(index, element) {
                let searchtext = $(element).data('search-text');
                let d = $(':contains("' + currentSearchText + '")', element);
                if (d.length > 0){
                    $(element).removeClass('hidden');
                }
            });
        });
    }

    initSingleServiceCodeParam(serviceCode, number){
        let serviceCodeParameterName = 'PARAM' + number + '_';
        let result = {};

        result['NUMBER'] = serviceCode['SERVICE_CODE_NUMBER'];
        result['NAME'] = serviceCode[serviceCodeParameterName + 'NAME'];
        result['REQUIRED'] = serviceCode[serviceCodeParameterName + 'REQUIRED'];
        result['TYPE'] = serviceCode[serviceCodeParameterName + 'TYPE'];
        result['MAX_LENGTH'] = serviceCode[serviceCodeParameterName + 'MAX_LENGTH'];

        if (result['TYPE'] == 'DATE'){
            result['VALUE'] = new Date();
        }
        return result;
    }

    convertSingleDaisyServiceParam(value, paramType){
        if (paramType == 'DATE'){
            let momentDate = moment(value, 'DD.MM.YYYY', true);
            return momentDate.toDate();
        }
        else if (paramType == 'TIME'){
            let momentDate = moment(value, 'HH:mm', true);
            return momentDate.toDate();
        }
        else if (paramType == 'INTEGER'){
            return parseInt(value);
        }
        else if (paramType == 'VARCHAR'){
            return value;
        }
    }

    fillExistingServiceCodes(existingCodes){
        if (existingCodes.length > 0) {
            existingCodes.map((existingServiceCode) => {
                let serviceCodePosition = this.findPosition(this.availableServiceCodes, existingServiceCode.SERVICE_CODE_ID, 'SERVICE_CODE_ID');
                let serviceCode = this.availableServiceCodes[serviceCodePosition];

                if (existingServiceCode.PARAM1_VALUE != ''){
                    let paramValue = existingServiceCode.PARAM1_VALUE;
                    let serviceCodeParam = serviceCode.parameter[0];
                    serviceCode.added = true;
                    serviceCodeParam.VALUE = this.convertSingleDaisyServiceParam(paramValue, serviceCodeParam.TYPE);
                }
                if (existingServiceCode.PARAM2_VALUE != ''){
                    let paramValue = existingServiceCode.PARAM2_VALUE;
                    let serviceCodeParam = serviceCode.parameter[1];
                    serviceCode.added = true;
                    serviceCodeParam.VALUE = this.convertSingleDaisyServiceParam(paramValue, serviceCodeParam.TYPE);
                }
                if (existingServiceCode.PARAM3_VALUE != ''){
                    let paramValue = existingServiceCode.PARAM3_VALUE;
                    let serviceCodeParam = serviceCode.parameter[2];
                    serviceCode.added = true;
                    serviceCodeParam.VALUE = this.convertSingleDaisyServiceParam(paramValue, serviceCodeParam.TYPE);
                }
            });
        }
    }

    getDisabledByShippingType(index){
        let shippingTypeToCheck = this.shippingTypes[index];
        if (shippingTypeToCheck.SHIPPING_TYPE_ID == this.packingSlip.SELECTED_SHIPPING_TYPE_ID){
            return false;
        }

        return !this.changeShippingTypeAllowed;
    }

    selectShippingType(index){
        let selectedShippingType = this.shippingTypes[index];
        this.packingDaisyService.getServiceCodes(this.packingSlip, selectedShippingType.SHIPPING_TYPE_ID).then((response) => {
            this.selectedShippingType = selectedShippingType;
            if (response.SERVICE_CODES.length > 0){
                this.availableServiceCodes = response.SERVICE_CODES;
                this.availableServiceCodes.map((serviceCode) => {
                    serviceCode.added = false;
                    serviceCode.parameter = new Array();
                    for (let i = 0; i <= 2; i++){
                        serviceCode.parameter[i] = this.initSingleServiceCodeParam(serviceCode, i + 1);
                    }
                });
            }
            else{
                this.availableServiceCodes = false;
            }
            this.fillExistingServiceCodes(response.EXISTING_SERVICE_CODES);
        });
    }

    resetShippingType(){
        this.selectedShippingType = false;
    }

    serviceCodeLabel(serviceCode){
        if (typeof(serviceCode) != 'undefined'){
            return serviceCode.SERVICE_CODE_NUMBER + ' - ' + serviceCode.SERVICE_CODE_NAME;
        }
    }

    clickedServiceCode(serviceCode){
        this.selectedServiceCodeToAdd = serviceCode;
    }

    findPosition(searchArray, value, keyName = 'id') {
        return _.findIndex(searchArray, [keyName, value]);
    }

    findValues(searchArray, value, keyName){
        return _.filter(searchArray, [keyName, value]);
    }

    addSelectedServiceCode(){
        let position = this.findPosition(this.availableServiceCodes, this.selectedServiceCodeToAdd.SERVICE_CODE_NUMBER, 'SERVICE_CODE_NUMBER');
        this.availableServiceCodes[position].added = true;

        this.selectedServiceCodeToAdd = false;
        $('.service-code-input').val('');
        $('.service-code-row').removeClass('hidden');
        this.Flash.create('success', 'Service-Code hinzugefügt.');
    }

    confirmSelection() {
        let addedServiceCodes = this.findValues(this.availableServiceCodes, true, 'added');
        this.packingDaisyService.finishPacking(this.packingSlip, this.selectedShippingType.SHIPPING_TYPE_ID, addedServiceCodes).then((response) => {
            this.Flash.create('success', 'Packzettel abgeschlossen.');
            this.$uibModalInstance.close(response);
            return;
        });
    };

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    };
}